export default __webpack_public_path__ + "static/feature-banner-europe-roadtrip-07b6b9a794218742fee480ad67b9e218.jpg";